<template>
  <div>
    <div class="containerN">
      <div class="logo">
        <img src="../static/home/logo.png" />
      </div>
      <a-menu
        :selectedKeys="activeIndex"
        mode="horizontal"
        class="el-menu"
        v-for="item in menus"
        @select="handleSelect"
        :key="item.key"
      >
        <a-sub-menu v-if="item.subs.length > 0" :key="item.key">
          <span
            slot="title"
            class="submenu-title-wrapper"
            :style="{ color: isTabs == item.id ? '#05A594' : '' }"
          >
            {{ item.title }}</span
          >
          <a-menu-item
            v-for="childitem in item.subs"
            :key="childitem.key"
            @titleClick="toPath"
          >
            <router-link :to="childitem.web_url">{{
              childitem.title
            }}</router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-menu-item :key="item.key" v-else>
          <router-link :to="item.web_url">{{
            item.title
          }}</router-link></a-menu-item
        >
      </a-menu>
      <!-- </div> -->

      <div class="search">
        <i class="el-icon-search" @click="toSearch"></i>
      </div>
      <div class="language" @click.stop="swichEN" v-if="lg == true">EN</div>
      <div class="language" @click.stop="swichCH" v-else>
        {{ $t("home.CH") }}
      </div>
      <div class="language1" v-if="lg == true">
        <el-button class="login" @click="showWx" v-if="!users">{{
          $t("home.login")
        }}</el-button>
        <div class="users" v-else @click="EnterUsers">{{ users.name }}</div>
        <div class="usersTab" v-if="userShow == true">
          <el-button class="usersBtnc" @click="toImprove">{{
            $t("home.Modify")
          }}</el-button>
          <el-button class="usersBtnc" @click="logout">{{
            $t("home.logout")
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="wxLogins" v-if="centerDialogVisible == true">
      <div class="dilog">
        <div class="dilog-title">{{ $t("home.Bind") }}</div>
        <i class="el-icon-close" @click="centerDialogVisible = false"></i>
        <el-form>
          <el-form-item>
            <el-input
              class="login-input1"
              placeholder="请输入手机号"
              v-model="form.mobile"
            ></el-input>
          </el-form-item>
          <div class="login-item1">
            <el-form-item>
              <el-input
                class="login-input2"
                placeholder="请你看到验证码"
                v-model="form.verify"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <img class="codec" :src="codeImage" @click="getVes" />
            </el-form-item>
          </div>
          <div class="login-item1">
            <el-form-item>
              <el-input
                class="login-input2"
                placeholder="请输入你收到的验证码"
                v-model="form.sms_verify"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <button
                class="codec"
                @click.stop="getCheckPhoneNo"
                type="button"
                :disabled="disabled"
              >
                {{ getPhoneCodeName }}
              </button>
            </el-form-item>
          </div>
          <el-button class="loginbtn" @click="saveAcount">{{
            $t("home.save")
          }}</el-button>
        </el-form>
      </div>
    </div>

    <!-- 微信登录二维码 -->
    <div class="wxLogins" v-if="showWX == true">
      <div class="wxLogin" v-if="isPhone == false">
        <div class="s">
          <i class="el-icon-close" @click="closeEw"></i>
          <div class="wxLogin-1">
            <div class="wxLogin-title">
              <img src="../static/home/logo.png" />
            </div>
            <vueQr :text="url + ''" class="wxLogin-ew"></vueQr>
            <div class="wxLogin-ew2" v-if="checked == false"></div>
          </div>
          <div class="t">请使用手机微信扫码登录</div>
        </div>
        <div
          class="checkBox"
          style="
            display: flex;
            width: 100%;
            text-align: center;
            /* padding-left: 50px; */
            box-sizing: border-box;
            justify-content: center;
          "
        >
          <!-- <div class="radioA"> -->
          登录即代表您已同意
          <div class="radioB" @click="toAgreement">《服务协议》</div>
          &
          <div class="radioB" @click="toPrivacy">《隐私政策》</div>
          <!-- </div> -->
        </div>
      </div>
      <div class="wxLogin-phone" v-else>
        <i class="el-icon-close" @click="closeEw"></i>
        <div class="wxLogin-1">
          <div class="wxLogin-title">{{ $t("home.qcode") }}</div>
          <vueQr :text="url + ''" class="wxLogin-ew"></vueQr>
          <div class="wxLogin-ew2" v-if="checked == false"></div>
          <div class="checkBox">
            <el-checkbox v-model="checked" class="wxLogin-check"
              >登录即代表您已同意</el-checkbox
            >
            <div class="radioA">
              <div class="radioB" @click="toAgreement">《服务协议》</div>
              &
              <div class="radioB" @click="toPrivacy">《隐私政策》</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
import { Menu } from "ant-design-vue";
import {
  UserWxVerify,
  UserSmsVerify,
  UserWxlogin,
  UserBindPhone,
  UserInfo,
  WxloginQrcode,
  WxloginUser,
} from "../api/login";
import { Menus } from "../api/home";
import vueQr from "vue-qr";
import "ant-design-vue/dist/antd.css";
export default {
  components: { vueQr },
  data() {
    return {
      isTabs: localStorage.getItem("isTabs")
        ? localStorage.getItem("isTabs")
        : "",
      userShow: false,
      showWX: false,
      users: {},
      centerDialogVisible: false,
      codeImage: "",
      getPhoneCodeName: this.$t("home.Obtain"),
      // getPhoneCodeName: '获取验证码',
      disabled: false,
      form: {},
      session_id: "",
      timeNum: 60,
      activeIndex: [],
      menus: [],
      lg: true,
      lang: "",
      showMenu: false,
      url: "",
      ticket: "",
      checked: true,
      timer: null,
      token: "",
      phone: null,
      language: "",
      isPhone: false,
    };
  },
  created() {
    JSON.parse(localStorage.getItem("userInfo"))
      ? (this.users = JSON.parse(localStorage.getItem("userInfo")))
      : (this.users = "");
    // console.log(this.$route.params.code)
    // console.log(this.users, this.users.name)
  },
  beforeDestroy() {
    EventBus.$off("navbar-event"); // 避免内存泄漏
    // 清除定时器，避免内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  //
  computed: {
    onRoutes() {
      return route.path;
    },
  },
  // watch: {
  //   $route: {
  //     handler: function (route) {
  //       console.log(this.$route.params.code)
  //     }
  //   }
  // },
  mounted() {
    // console.log(localStorage.getItem('Token'))
    if (localStorage.getItem("Token") !== null || undefined || "") {
      this.getUserInfo();
    }
    this.users = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.users, this.users.name)
    this.getVes();
    this.getMenus();
    this.language = localStorage.getItem("language");
    console.log(this.language == null, "--152--");
  },
  methods: {
    toAgreement() {
      // this.$router.push('/commitment')
      window.open("/agreement", "_blank");
      // this.$router.push({ path: '/commitment', target: '_blank' });
    },
    toPrivacy() {
      // this.$router.push('/privacy')
      window.open("/privacy", "_blank");

      // this.$router.push({ path: '/privacy', target: '_blank' });
    },
    async getUserInfo() {
      const { data } = await UserInfo(localStorage.getItem("Token"));
      console.log(data);
      this.users = data.data;
      this.phone = data.data.phone;
      localStorage.setItem("userInfo", JSON.stringify(this.users));
    },
    async showWx() {
      if (device.mobile()) {
        console.log("移动手机");
        this.isPhone = true;
      } else if (device.ipad()) {
        console.log("ipad");
        this.isPhone = true;
      } else if (device.desktop()) {
        console.log("电脑");
        this.isPhone = false;
      }
      this.showWX = true;
      const { data } = await WxloginQrcode();
      // console.log(data.data)
      this.url = data.data.url;
      this.ticket = data.data.ticket;
      this.timer = setInterval(async () => {
        const { data } = await WxloginUser(this.ticket);
        // console.log(data)
        // console.log(data.data)
        if (data.status == 400) {
          // clearInterval(this.timer);
          // this.timer = null;
          return;
        } else {
          // localStorage.setItem('Token', data.data.token)
          localStorage.setItem("Token", data.data.token);
          this.token = data.data.token;
          this.phone = data.data.phone;
          if (data.data.phone == null) {
            this.centerDialogVisible = true;
          } else {
            this.getUserInfo();
            this.centerDialogVisible = false;
            console.log(data.data, "---154---");
            // this.users = data.data.name
            console.log(this.users);
          }
          this.showWX = false;
          // 清除定时器，无论是否需要绑定手机号
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 2000);
    },
    toPath({ key, domEvent }) {
      console.log(key, domEvent);
    },
    async getMenus() {
      const { data } = await Menus();
      this.menus = data.data;
      if (localStorage.getItem("isTabs")) {
        this.activeIndex = [localStorage.getItem("isTabs")];
        this.isTabs = localStorage.getItem("isTabs");
      } else {
        this.activeIndex = [this.menus[0].id];
        this.isTabs = this.menus[0].id;
      }
    },
    handleOpen(key, keyPath) {
      console.log("打开：", key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log("关闭：", key, keyPath);
    },
    handleSelect({ item, key, selectedKeys }) {
      // console.log("选择：", key, selectedKeys);
      this.activeIndex = selectedKeys;
      this.isTabs = parseInt(key);
      localStorage.setItem(
        "isTabs",
        String(key).includes("-") ? key.split("-")[0] : key
      );
    },

    swichCH() {
      this.lg = true;
      console.log("-zh-CN");
      localStorage.setItem("language", "zh-CN");
      this.$i18n.locale = "zh-CN";

      console.log(this.$i18n.locale, "00000");
      setTimeout(() => {
        this.$router.go(0);
      }, 2000);

      // this.$i18n.locale = 'en-US'
      // console.log(this.$router)
      // location.href =this.$router.history.current.path
    },
    swichEN() {
      console.log("--en-US");
      this.lg = false;
      localStorage.setItem("language", "en-US");
      this.$i18n.locale = "en-US";

      console.log(this.$i18n.locale, "00000");

      setTimeout(() => {
        this.$router.go(0);
      }, 2000);
      // this.$router.go(0)
      // this.$i18n.locale = 'zh-CN'
      // location.href =this.$router.history.current.path
    },
    // 获取图片验证码
    async getVes() {
      const res = await UserWxVerify();
      // console.log(res)
      this.codeImage = res.data.data.img;
      this.session_id = res.data.data.session_id;
      // console.log(this.codeImage)
    },
    // 获取手机验证码方法
    async getCheckPhoneNo() {
      const reg =
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (!reg.test(this.form.mobile)) {
        this.$message({
          type: "warning",
          message: "手机号格式错误",
        });
        return;
      }
      this.disabled = true;
      await UserSmsVerify({
        verify: this.form.verify,
        mobile: this.form.mobile,
        session_id: this.session_id,
      }).then((res) => {
        // console.log(res,'---280---')
        if (res.data.status !== 200) {
          this.$notify({
            title: "提示",
            message: res.data.msg,
            duration: 10000,
          });
          this.getVes();
          this.disabled = false;
          return;
        } else {
          this.$notify({
            title: "提示",
            message: res.data.msg,
            duration: 10000,
          });
          let timer = setInterval(() => {
            this.timeNum -= 1;
            this.getPhoneCodeName = `重新发送 ${this.timeNum}`;
          }, 1000);
          setTimeout(() => {
            clearInterval(timer);
            this.timeNum = 60;
            this.disabled = false;
            this.getPhoneCodeName = this.$t("home.Obtain");
          }, 60000);
        }
        console.log(res);
      });
    },
    // 绑定手机号
    async saveAcount() {
      const { data } = await UserBindPhone({
        mobile: this.form.mobile,
        sms_verify: this.form.sms_verify,
        token: localStorage.getItem("Token"),
      });
      console.log(data);
      if (data.status == 200) {
        this.centerDialogVisible = false;
        this.$notify({
          title: "提示",
          message: data.msg,
          duration: 10000,
        });
        this.getUserInfo();
        this.$router.push("/improve");
      } else {
        this.$notify({
          title: "提示",
          message: data.msg,
          duration: 10000,
        });
        this.getVes();
      }
    },
    EnterUsers() {
      this.userShow = !this.userShow;
      console.log(this.userShow, "----401----");
    },
    // LeaveUsers() {
    //   this.userShow = false
    //   console.log(this.userShow, '----405----')
    // },
    // 退出登录
    logout() {
      localStorage.removeItem("Token");
      localStorage.removeItem("userInfo");
      this.userShow = false;
      this.users = "";
      // console.log(this.users.length);
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      // location.reload()
    },
    toImprove() {
      if (this.phone == null) {
        this.centerDialogVisible = true;
        this.userShow = false;
      } else {
        console.log(this.$route.path);
        // this.$router.push('/improve')
        if (this.$route.path !== "/improve") {
          this.$router.push("/improve");
        }
        this.userShow = false;
      }
    },
    toSearch() {
      this.$router.push("/search");
    },
    closeEw() {
      this.showWX = false;
      localStorage.removeItem("Token");
      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
  created() {
    EventBus.$on("navbar-event", () => {
      this.showWx();
      console.log(11111);
    });
    const language1 = localStorage.getItem("language");
    if (language1 === "en-US") {
      this.lg = false;
    } else if ("zh-CN") {
      this.lg = true;
    } else {
      this.lg = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "PingFang SC";
  src: url("@/assets/font/PingFangRegular.ttf");
}

::v-deep .ant-menu-submenu-popup,
.ant-menu-submenu-placement-bottomLeft {
  ul {
    top: 47px !important;
  }
}

.containerN {
  width: 100%;
  height: 90px;
  // background: linear-gradient(90deg, #ffffff 0%, #ffffff 100%);
  display: flex;
  // padding-top: 33px;
  padding-left: 46px;
  top: 0px;
  box-sizing: border-box;
  align-items: center;
  position: fixed;
  z-index: 999;
  background-color: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;

  .logo {
    height: 90px;
    display: flex;
    align-items: center;
    margin-right: 146px;

    img {
      width: 285px;
      height: 59px;
      box-sizing: border-box;
    }
  }

  .menubg {
    animation: xa 0.8s;
    animation-fill-mode: forwards;
    background: rgba(255, 255, 255, 0.9);
    height: 295px;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
  }

  // @keyframes xa {
  //   0% {
  //     transform: translateY(-400px);
  //   }

  //   100% {
  //     transform: translateY(120px);
  //   }
  // }

  .el-menu {
    border: none;
    margin-right: 40px;
    height: 60px;
    align-items: center;
    display: flex;

    .ant-menu-item {
      // font-family: PingFang SC;
      font-size: 20px;
      font-weight: 700;
      height: 90px;
      display: flex;
      align-items: center;

      a:hover {
        color: #0ba39a;
      }
    }

    .ant-menu-item-active {
      color: #0ba39a;
    }

    .submenu-title-wrapper {
      // font-family: PingFang SC;
      font-size: 20px;
      font-weight: 700;
      height: 90px;
      display: flex;
      align-items: center;
      // color: #05A594;
      // margin-top: -100px;
    }
  }

  .ant-menu-horizontal {
    .ant-menu-item-selected {
      a {
        /* color: #1890ff; */
        color: #0ba39a;
      }
    }
  }

  .ant-menu-submenu {
    height: 90px !important;
    // top: 0px !important;
  }

  .ant-menu-submenu-title:nth-child(1) {
    display: none;
  }

  ::v-deep .ant-menu-submenu-title {
    padding: 0 2px !important;
    box-sizing: border-box !important;
    height: 42px;
    display: flex;
    align-items: center;
  }

  .search {
    width: 18px;
    // height: 18px;
    // background: #040000;
    margin-left: 280px;
  }

  .language {
    width: 27px;
    // height: 20px;
    font-size: 20px;
    font-family: "PingFang SC";
    font-weight: 600;
    color: #000000;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }

  .language1 {
    position: relative;

    .login {
      width: 74px;
      height: 36px;
      background: linear-gradient(270deg, #05cebd 0%, #08bead 100%);
      border-radius: 24px;
      margin-left: 40px;
      font-size: 16px;
      font-family: "PingFang SC";
      font-weight: 600;
      color: #ffffff;

      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .users {
      margin-left: 84px;
      height: 48px;
      width: 48px;
      border-radius: 24px;
      background-color: darkorange;
      margin-bottom: 10px;
      text-align: center;
      line-height: 48px;
      font-size: 14px;
    }

    .usersTab {
      z-index: 111;
      position: absolute;
      right: 0;
      // bottom: -10px;
      width: 100px;
      height: 100px;
      background-color: #fff;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;

      .usersBtnc {
        flex: 1;
        margin-left: 0px;
        // height: 40px;
        // background-color: #05CEBD;
      }
    }
  }
}

.wxLogin-phone {
  width: 1000px;
  height: 800px;
  padding-top: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 23px 0px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  left: 50%;
  top: 50%;
  transform: translate(-500px, -400px);
  z-index: 99;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;

  .el-icon-close {
    position: absolute;
    right: 20px;
    top: 30px;
    font-size: 80px;
  }

  .wxLogin-1 {
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;
    overflow: hidden;

    .wxLogin-title {
      width: 1000px;
      height: 80px;
      display: flex;
      justify-content: center;
      font-size: 80px;
      font-weight: 600;
    }

    .wxLogin-ew {
      width: 164px;
      height: 164px;
      margin-top: 40px;
      position: relative;
    }

    .wxLogin-ew2 {
      width: 330px;
      height: 330px;
      margin-top: 24px;
      position: fixed;
      top: 200px;
      left: 332px;
      background-image: url("../static/home/erh.png");
      background-size: 184px 184px;
      z-index: 999;
    }

    .checkBox {
      display: flex;
      flex-wrap: wrap;
      width: 1000px;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      // padding-left: 20px;
      // padding-right: 20px;
      // font-size: 12px;

      ::v-deep .wxLogin-check {
        display: flex;
        align-items: center;

        .el-checkbox__input {
          // margin-top: 4px;
          width: 60px;
          // height: 60px;

          .el-checkbox__inner {
            width: 60px;
            height: 60px;
          }
        }

        .el-checkbox__label {
          font-size: 50px;
          color: none;
          padding-left: 4px;
        }

        .el-checkbox__input.is-checked + .el-checkbox__label {
          /* color: #409EFF; */
          color: #333333;
        }
      }

      .radioA {
        display: flex;
        flex-wrap: nowrap;
        font-size: 50px;
        align-items: center;

        .radioB:hover {
          display: inline-block;
          // width:120px;
          color: #08bead !important;
          // font-size: 10px !important;
        }
      }
    }
  }
}

.wxLogin {
  position: fixed;
  width: 500px;
  height: 490px;
  // padding-top: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 23px 0px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  left: 50%;
  top: 50%;
  transform: translate(-230px, -280px);
  z-index: 99;
  box-sizing: border-box;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  position: relative;
  // flex-wrap: wrap;

  .el-icon-close {
    position: absolute;
    right: 20px;
    top: 30px;
    font-size: 28px;
    cursor: pointer;
  }

  .wxLogin-1 {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    overflow: hidden;
    padding-top: 20px;

    .wxLogin-title {
      width: 268px;
      // height: 24px;
      display: flex;
      justify-content: center;
      font-size: 24px;
      font-weight: 600;
    }

    .wxLogin-ew {
      width: 224px;
      height: 224px;
      // margin-top: 24px;
      position: relative;
    }

    .wxLogin-ew2 {
      width: 202px;
      height: 202px;
      margin-top: 24px;
      position: fixed;
      top: 108px;
      left: 123px;
      background-image: url("../static/home/erh.png");
      background-size: 162px 162px;
      z-index: 999;
    }

    .checkBox {
      display: flex;
      flex-wrap: wrap;
      width: 410px;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      // padding-left: 20px;
      // padding-right: 20px;
      // font-size: 12px;

      ::v-deep .wxLogin-check {
        display: flex;
        align-items: center;

        .el-checkbox__input {
          margin-top: 4px;
        }

        .el-checkbox__label {
          font-size: 16px;
          color: none;
          padding-left: 4px;
        }

        .el-checkbox__input.is-checked + .el-checkbox__label {
          /* color: #409EFF; */
          color: #333333;
        }
      }

      .radioA {
        display: flex;
        flex-wrap: nowrap;
        font-size: 16px;
        align-items: center;

        .radioB:hover {
          display: inline-block;
          // width:120px;
          color: #08bead !important;
          // font-size: 10px !important;
        }
      }
    }
  }
}

.wxLogins {
  width: 1920px;
  height: 100vh;
  position: fixed;
  z-index: 100;
}

.wxLogins::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 设置遮罩的颜色和透明度 */
}

::v-deep .s {
  height: 438px;
  width: 100%;
  background: linear-gradient(225deg, #fffbf5 0%, #e9f7f9 100%);
  border-radius: 12px;

  .wxLogin-1 {
    display: flex;
    flex-wrap: wrap;

    .wxLogin-title {
      width: 100%;
      height: 47px;
      display: flex;
      justify-content: center;
      font-size: 80px;
      font-weight: 600;

      img {
        width: 308px;
        height: 67px;
      }
    }

    .wxLogin-ew {
      width: 254px;
      height: 254px;
      margin-top: 40px;
      position: relative;
    }
  }

  .t {
    width: 100%;
    display: flex;
    justify-content: center;
    // font-family: PingFang SC;
    font-weight: 600;
    margin-top: 29px;
    font-size: 18px;
    color: #333333;
  }
}

.checkBox {
  display: flex;
  align-items: center;
  height: 50px;
  // font-family: PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #666666;

  .radioB:hover {
    display: inline-block;
    // width:120px;
    color: #08bead !important;
    cursor: pointer;
    // font-size: 10px !important;
  }
}

.dilog {
  width: 660px;
  // height: 368px;
  background: #ffffff;
  box-shadow: 0px 2px 22px 0px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  z-index: 99;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-330px, -278px);
  padding-left: 86px;
  padding-right: 86px;
  box-sizing: border-box;
  padding-bottom: 40px;
  // position: relative;

  .loginbtn {
    width: 134px;
    height: 60px;
    background: linear-gradient(105deg, #08bead 0%, #05cebd 100%);
    border-radius: 6px;
    font-size: 20px;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .dilog-title {
    // width: 161px;
    // height: 47px;
    font-size: 32px;
    // font-family: Milky-Han-Mono-CN-Heavy, Milky-Han-Mono-CN;
    // font-weight: 800;
    // color: #333333;
    margin-top: 45px;
  }

  .el-icon-close {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 25px;
    top: 25px;
    font-size: 20px;
    // background: #9B9B9B;
  }

  ::v-deep .login-input1 {
    width: 488px;
    height: 60px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid rgba(151, 151, 151, 0.3);
    margin-top: 55px;
    margin-bottom: 20px;

    input {
      width: 488px;
      height: 60px;
    }
  }

  .login-item1 {
    display: flex;
    margin-bottom: 20px;

    .codec {
      width: 156px;
      height: 60px;
      border-radius: 6px;
      border: 1px solid rgba(151, 151, 151, 0.6);
      margin-left: 13px;

      img {
        width: 156px;
        height: 60px;
        border-radius: 6px;
      }
    }

    ::v-deep .login-input2 {
      width: 320px;
      height: 60px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid rgba(151, 151, 151, 0.3);
      padding: 0px;

      .el-input__inner {
        width: 320px;
        height: 60px;
      }
    }
  }
}
</style>
